








































import Vue, { PropType } from "vue";

interface NavItem {
  name: string;
  label: string;
  isCurrent: boolean;
  to: Record<string, unknown>;
}

export default Vue.extend({
  name: "HeaderDashboard",
  props: {
    email: {
      type: String,
      default: ""
    },
    customers: {
      type: Array as PropType<Array<Record<string, unknown>>>,
      default: () => [] as Array<Record<string, unknown>>
    },
    expire: {
      type: String,
      default: null
    },
    hash: {
      type: String,
      default: null
    },
    token: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: "loading"
    }
  },
  computed: {
    isLoading(): boolean {
      return this.status === "loading";
    },

    /**
     * Falls back to the view's own title so the page is never left with an
     * empty h1 when the customer record carries no name.
     */
    customerName(): string {
      const name = this.customers
        .map(customer => customer.name)
        .find(name => typeof name === "string" && name.trim().length > 0);

      return (
        (name as string) ||
        this.$t("customer-dashboard.header-not-loaded").toString()
      );
    },

    navItems(): NavItem[] {
      const query = {
        email: this.email,
        expire: this.expire,
        hash: this.hash,
        token: this.token
      };

      return [
        {
          name: "CustomerDashboard",
          label: this.$t(
            "appointments-customer-dashboard.appointment"
          ).toString()
        },
        {
          name: "GiftcardsDashboard",
          label: this.$t("giftcards-customer-dashboard.title").toString()
        }
      ].map(item => ({
        ...item,
        isCurrent: this.$route.name === item.name,
        to: {
          name: item.name,
          params: { locale: this.$i18n.locale },
          query
        }
      }));
    }
  }
});
